var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0241 2C7.13099 1.99937 2.95988 5.54799 2.17646 10.3779C1.39305 15.2079 4.22866 19.893 8.87106 21.439C9.37106 21.529 9.55006 21.222 9.55006 20.958C9.55006 20.721 9.54206 20.093 9.53906 19.258C6.76406 19.858 6.17806 17.92 6.17806 17.92C5.99538 17.317 5.60264 16.7993 5.07106 16.461C4.17106 15.842 5.14006 15.856 5.14006 15.856C5.78074 15.9438 6.34461 16.3235 6.66706 16.884C6.94 17.3803 7.39982 17.747 7.94437 17.9026C8.48891 18.0583 9.07308 17.99 9.56706 17.713C9.61348 17.207 9.8386 16.7341 10.2021 16.379C7.98806 16.128 5.66006 15.272 5.66006 11.449C5.64778 10.4602 6.01496 9.5043 6.68606 8.778C6.38241 7.91731 6.41817 6.97325 6.78606 6.138C6.78606 6.138 7.62306 5.869 9.52806 7.159C11.1619 6.71101 12.8862 6.71101 14.5201 7.159C16.4261 5.868 17.2621 6.138 17.2621 6.138C17.6317 6.97286 17.6674 7.91757 17.3621 8.778C18.0356 9.50423 18.4025 10.4626 18.3861 11.453C18.3861 15.286 16.0561 16.128 13.8341 16.375C14.3134 16.8651 14.5592 17.5373 14.5091 18.221C14.5091 19.555 14.4971 20.631 14.4971 20.958C14.4971 21.225 14.6751 21.535 15.1841 21.437C19.8245 19.8884 22.6571 15.203 21.8721 10.3743C21.0871 5.54565 16.9161 1.99888 12.0241 2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.8cb5c77c9fa8f585544bae8e5b39c259.svg";
export { ForwardRef as ReactComponent };